export const getAddressPayload = (address: { [key: string]: string }) => {
  const getLastPart = (key: string) => key.split('.').pop() || key;

  const payload: { [key: string]: string } = {};

  for (const [fieldName, value] of Object.entries(address)) {
    const lastPart = getLastPart(fieldName);
    payload[lastPart] = value;
  }

  return payload;
};
